// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createMaintenancePlan} from '../../shared/repositories';
import {getMaintenancePlanReportCriteria} from '../../shared/services/reports';

export const createMaintenancePlanReport = () =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const maintenancePlanReportCriteria = getState().reports.maintenancePlan.criteria;

        const reportCriteria = getMaintenancePlanReportCriteria(maintenancePlanReportCriteria);

        try {

            const data = await createMaintenancePlan(reportCriteria);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: actions.CREATE_MAINTENANCE_PLAN_REPORT_SUCCESS
            });

            dispatch({
                hasNoResult,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/action-creators/report.js